var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"botao",class:_vm.contents.content.alignment || 'left',attrs:{"contents":_vm.contents.content}},[_vm._v(_vm._s(_vm.contents.content.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }